// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3ZUWa","itemTitle":"ClientEmergencyInfo_itemTitle__2vNDH","itemText":"ClientEmergencyInfo_itemText__335I7"};